module.exports = __webpack_public_path__ + "img/used-car-check-point.77069605.jpg";